import { serviceRequest } from 'utils/http';
import { Service } from 'common/api';

export function getUserStudiesAPI() {
  return serviceRequest(() => Service.studyControllerCurrentUserStudies());
}
